import {
  CUSTOM_ELEMENTS_SCHEMA,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { Task } from '../../../../../shared/models/task';
import { TaskService } from '../../../../../shared/services/task.service';
import { SubjectTypeService } from '../../../../../shared/services/subject-type.service';
import { take } from 'rxjs/operators';
import { MailMergeWizardComponent } from '../../mail-merge-wizard/mail-merge-wizard/mail-merge-wizard.component';
import { MatDialog } from '@angular/material/dialog';
import { SubjectLinkService } from 'app/shared/services/subject-link.service';
import { AuthService } from 'app/shared/services/auth.service';
//import { FusePromptEmailDialogComponent } from './prompt-email-dialog/prompt-email-dialog.component';
import { messageService } from 'app/shared/services/messages/message.module';
import 'add-to-calendar-button';
import { atcb_action } from 'add-to-calendar-button';
import { PreviewEmailDialogComponent } from './preview-email-dialog/preview-email-dialog.component';

@Component({
  selector: 'fuse-task-list-item',
  templateUrl: './task-list-item.component.html',
  styleUrls: ['./task-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class FuseTaskListItemComponent implements OnInit, OnDestroy, OnChanges {
  _task: Task = null;
  locked = false;
  summary = '';
  listOfValues = [];
  currentStatus = 10;
  calendarTitle: string;
  calendarDateDue: string;
  calendarDescription: string = '';
  calendarName = '';

  @Input() set task(value: Task) {
    this._task = value.toggleStar ? value : new Task(value);
    this.summary =
      this._task.summary ||
      (this._task && this._task.taskType ? this._task.taskType.name : '');
  }
  get task(): Task {
    return this._task;
  }

  @Input() onSubjectDashboard: boolean;
  @Input() readOnly = false;

  @HostBinding('class.selected') selected: boolean;

  @ViewChild('btnAddToCalender')
  btnAddToCalender: ElementRef<HTMLButtonElement>;

  onSelected: Subscription;

  constructor(
    private taskService: TaskService,
    public subjectTypeService: SubjectTypeService,
    private subjectLinkService: SubjectLinkService,
    public dialog: MatDialog
  ) {
    this.selected = false;
  }

  public getTaskTypeName(): string {
    if (this.task && this.task.taskType) {
      let s = this.task.taskType.name || 'Unknown Status';
      if (this.task.taskStatus < 30) {
        s = s + '/' + this.task.taskStatusName;
      }
      return s;
    }
    return 'Unknown Task Type ' + this.task.taskTypeId;
  }

  public getSubjectLine(): string {
    if (this.task.subject === null || this.task.subject === undefined) {
      return 'This task is not linked to a subject';
    } else {
      if (this.task.subject.isReferral) {
        return 'Referral ' + this.task.subject.summary;
      } else {
        return (
          this.getSubjectTypeNameFromId(this.task.subject.subjectTypeId) +
          ' ' +
          this.task.subject.summary
        );
      }
    }
  }

  public getSubjectTypeNameFromId(id: number): string {
    return this.subjectTypeService.getName(id);
  }

  ngOnInit() {
    this.onSelected = this.taskService.onSelected.subscribe((task: Task) => {
      if (task) {
        this.selected = this.task ? this.task.id === task.id : false;
      }
    });
    this.calendarDateDue = this.task.dateDue.toString().replace(/([T]).*/g, '');
    this.calendarName = this.task.summary
      ? this.task.summary
      : this.task.taskType.name;
    this.calendarTitle = 'InCase365: ' + this.calendarName;
    this.calendarDescription = this.task.subject
      ? this.getSubjectLine() // this.task.subject.summary
      : '';
  }

  ngOnChanges() {
    this.locked =
      this.task &&
      (this.task.readOnly ||
        this.task.taskStatus > 20 ||
        (this.task.subject && this.task.subject.archived));
  }

  ngOnDestroy() {
    this.onSelected?.unsubscribe();
  }

  editTask(event) {
    // Show edit box to edit the task
    event.stopPropagation();
    this.taskService.onNewTaskClicked.next(this.task);
  }

  toggleStar(event) {
    event.stopPropagation();
    this.task.toggleStar();
    this.saveTask();
  }

  toggleImportant(event) {
    event.stopPropagation();
    this.task.toggleImportant();
    this.saveTask();
  }

  markTaskAsCompleted(event) {
    event.stopPropagation();
    this.currentStatus = this.task.taskStatus;
    setTimeout(() => {
      if (
        this.task.taskType &&
        this.task.subject &&
        this.task.taskType.emailOrLetter &&
        this.task.taskType.emailOrLetter &&
        this.task.taskType.emailOrLetter !== 1
      ) {
        this.subjectLinkService
          .getLinkedSubjects(this.task.subject)
          .pipe(take(1))
          .subscribe(
            (response: any[]) => {
              if (response && response.length > 0) {
                if (this.task.taskType.promptToEmail) {
                  if (this.hasEmail) {
                    const subjectTypeId = this.taskService.personSubjectTypeId;
                    // 13/06/2024 (YA): Removed existing functionality for display email prompt
                    // const linkedSubjects = response.filter(
                    //   (i) => i.subjectTypeId === subjectTypeId && i.email
                    // );
                    let linkedSubjectsMailMerge = response.filter(
                      (i) => i.subjectTypeId !== this.task.subject.subjectTypeId
                    );
                    // if (linkedSubjects.length > 1) {
                    //   this.displayPromptEmailDialog(
                    //     linkedSubjects,
                    //     linkedSubjectsMailMerge
                    //   );
                    // } else {
                    linkedSubjectsMailMerge = linkedSubjectsMailMerge.filter(
                      (i) =>
                        (i.subjectTypeId == subjectTypeId &&
                          i.email &&
                          i.receiveTaskNotification) ||
                        i.subjectTypeId !== subjectTypeId
                    );
                    if (
                      linkedSubjectsMailMerge.length > 0 &&
                      linkedSubjectsMailMerge
                    ) {
                      this.displayMailMergeWizard(linkedSubjectsMailMerge);
                    } else {
                      this.task.taskStatus = this.currentStatus;
                      this.locked = false;
                      messageService.error(
                        'There are no subjects that can be contacted by email',
                        'No Email Address Found'
                      );
                      this.taskService.getTasks();
                    }
                    //}
                  } else {
                    // no email template specified
                    this.task.taskStatus = this.currentStatus;
                    this.locked = false;
                    messageService.error(
                      'Please add an email template to the task type to complete this task',
                      'Email template missing'
                    );
                  }
                } else {
                  const subjectTypeId = this.taskService.personSubjectTypeId;
                  let linkedSubjectsMailMerge = response;
                  linkedSubjectsMailMerge = linkedSubjectsMailMerge.filter(
                    (i) => {
                      if (this.task.taskType.emailOrLetter === 2) {
                        return (
                          (i.subjectTypeId === subjectTypeId &&
                            i.email &&
                            i.receiveTaskNotification) ||
                          (i.subjectTypeId !==
                            this.task.subject.subjectTypeId &&
                            i.subjectTypeId !== subjectTypeId)
                        );
                      } else {
                        return (
                          i.subjectTypeId !== this.task.subject.subjectTypeId
                        );
                      }
                    }
                  );
                  if (
                    linkedSubjectsMailMerge.length > 0 &&
                    linkedSubjectsMailMerge
                  ) {
                    // disaply the mail merge wizard
                    this.displayMailMergeWizard(linkedSubjectsMailMerge);
                  } else {
                    //no email for mail merge
                    this.task.taskStatus = this.currentStatus;
                    this.locked = false;
                    messageService.error(
                      'There are no subjects that can be contacted by email',
                      'No Email Address Found'
                    );
                    this.taskService.getTasks();
                  }
                }
              } else {
                this.taskService.markTaskAsCompleted(this.task, [
                  this.task.subject.uid,
                ]);
              }
            }
            //(error) => console.error(error)
          );
      } else {
        this.taskService.markTaskAsCompleted(this.task, []);
      }
    }, 100);
    this.task.taskStatus = 30;
    this.locked = true;
  }

  markTaskAsAbandoned(event) {
    event.stopPropagation();
    this.taskService.markTaskAsAbandoned(this.task);
  }

  saveTask() {
    this.taskService
      .save(new Task(this.task), `Task '${this.task.summary}' saved`)
      .subscribe();
  }

  get hasLetter() {
    return this.task.taskType.attachedDocXFiles > 0;
  }

  get hasEmail() {
    return (
      this.task.taskType.emailOrLetter === 2 &&
      this.task.taskType.emailTemplateId
    );
  }

  // Get list of subjects to be used by the mail merge.
  // This list should contain one Subject UID for each Subject Type linked to the subject.
  displayMailMergeWizard(linkedSubjects: any[], emailPromptValues = []) {
    if (this.hasLetter || this.hasEmail) {
      // display the dialog...
      const wizardDialogRef = this.dialog.open(MailMergeWizardComponent, {
        data: {
          subjects: linkedSubjects,
          peopleSubjects: emailPromptValues,
          taskTypeEmailOrLetter: this.task.taskType.emailOrLetter,
        },
      });

      // subscribe to the afterClosed.  If user cancelled then result will be undefined
      wizardDialogRef.afterClosed().subscribe((result) => {
        if (result && result.subjectUIDList) {
          if (result.preview) {
            this.taskService
              .displayAndEditEmail(this.task, result.subjectUIDList)
              .subscribe((emailTemplate) => {
                const previewDialog = this.dialog.open(
                  PreviewEmailDialogComponent,
                  { data: { emailTemplate } }
                );
                previewDialog.afterClosed().subscribe((template) => {
                  if (template) {
                    this.taskService.markTaskAsCompleted(
                      this.task,
                      result.subjectUIDList,
                      template
                    );
                  } else {
                    // if no template returned then exited preview - update task list etc - this makes sure that any temporary changes are discarded if/as necessary
                    this.taskService.getTasks();
                  }
                });
              });
          } else {
            //this.listOfValues.forEach((uid) => result.subjectUIDList.push(uid));
            // user selected subjects if/as required.
            // Call the markTaskAsCompleted method with the list of subjects selected
            this.taskService.markTaskAsCompleted(
              this.task,
              result.subjectUIDList
            );
          }
        } else {
          // not agreed to create documents - update task list etc - this makes sure that any temporary changes are discarded if/as necessary
          this.taskService.getTasks();
        }
      });
    } else {
      switch (this.task.taskType.emailOrLetter) {
        case 2:
          // no email template specified
          messageService.error(
            'Please add an email template to the task type to complete this task',
            'Email template missing'
          );
          this.task.taskStatus = this.currentStatus;
          this.locked = false;
          this.taskService.getTasks();
          break;
        case 3:
          // no mail merge templates
          messageService.error(
            'Please add at least one mail merge template to the task type to complete this task',
            'Mail merge template not found'
          );
          this.task.taskStatus = this.currentStatus;
          this.locked = false;
          this.taskService.getTasks();
          break;
      }
    }
  }

  // displayPromptEmailDialog(linkedSubjects: any[], wizardLinkedSubjects: any[]) {
  //   const emailDialog = this.dialog.open(FusePromptEmailDialogComponent, {
  //     data: { subjects: linkedSubjects },
  //   });
  //   emailDialog.afterClosed().subscribe((result) => {
  //     if (result && result.uidStrings) {
  //       const subjectTypeId = this.taskService.personSubjectTypeId;
  //       const notPeople = wizardLinkedSubjects.filter(
  //         (i) => i.subjectTypeId !== subjectTypeId
  //       );

  //       if (notPeople.length > 0) {
  //         this.displayMailMergeWizard(wizardLinkedSubjects, result.uidStrings);
  //       } else {
  //         if (result.preview) {
  //           this.taskService
  //             .displayAndEditEmail(this.task, result.uidStrings)
  //             .subscribe((emailTemplate) => {
  //               const previewDialog = this.dialog.open(
  //                 PreviewEmailDialogComponent,
  //                 { data: { emailTemplate } }
  //               );
  //               previewDialog.afterClosed().subscribe((template) => {
  //                 if (template) {
  //                   this.taskService.markTaskAsCompleted(
  //                     this.task,
  //                     result.uidStrings,
  //                     template
  //                   );
  //                 }
  //               });
  //             });
  //         } else {
  //           this.taskService.markTaskAsCompleted(this.task, result.uidStrings);
  //         }
  //       }
  //     } else {
  //       this.taskService.getTasks();
  //     }
  //   });
  // }

  AddToCalendar(e) {
    atcb_action(
      {
        name: this.calendarTitle,
        description: this.calendarDescription,
        options: ['Microsoft365', 'Outlook.com', 'MicrosoftTeams', 'iCal'],
        startDate: this.calendarDateDue,
        endDate: this.calendarDateDue,
        hideTextLabelButton: true,
        buttonStyle: 'round',
        startTime: '12:00',
        endTime: '12:00',
        timeZone: 'currentBrowser',
        listStyle: 'modal',
      },
      this.btnAddToCalender.nativeElement
    );
  }
}
